// extracted by mini-css-extract-plugin
module.exports = {"head_tab":"CaseTab_head_tab__2hHa1","head_tab_main":"CaseTab_head_tab_main__2_-VJ","tab_link":"CaseTab_tab_link__1RZDP","home":"CaseTab_home__2GuWo"};